const push = async (eventName, data) => {
    if (process.client) {
        data.event = eventName;
        window.dataLayer?.push(data)
    }
};

export default {push};
